import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=452b6355&"
import script from "./AddModal.vue?vue&type=script&lang=js&"
export * from "./AddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports